export default __webpack_public_path__ + "29dca3c60b93870b54213c087202eec9.svg";